import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { fetchAR, deleteAR, fetchARDetail, clearARDetail } from '../../actions/arap_actions';
import { setDefaultOfForm } from '../../actions/purchaseOrders_actions';
import { checkPassword, clearCheckPassword } from '../../actions/settings_actions';

import ARList from '../../components/AR/ARList';

const arList = reduxForm({
    form: 'arList',
    destroyOnUnmount: true,
})(ARList);

const selector = formValueSelector('arList');

function mapStateToProps(state) {
    const fromDate = selector(state, 'FromDate');
    const toDate = selector(state, 'ToDate');
    const days = selector(state, 'Days');
    return {
        fromDate,
        toDate,
        days,
        ar: state.arap.ar,
        isLoading: state.arap.arIsLoading,
        error: state.arap.arError,
        arDetail: state.arap.arDetail,
        arDetailError: state.arap.arDetailError,
        arDetailIsLoading: state.arap.arDetailIsLoading,
        checkPassword: state.settings.checkPassword,
        checkPasswordSuccess: state.settings.checkPasswordSuccess,
        checkPasswordFailure: state.settings.checkPasswordFailure,
    };
}

export default connect(mapStateToProps, {
  fetchAR,
  deleteAR,
  fetchARDetail,
  clearARDetail,
  setDefaultOfForm,
  checkPassword,
  clearCheckPassword,
})(arList);



// WEBPACK FOOTER //
// ./master/jsx/containers/AR/ARList.jsx